import { Container, ContainerProps, Divider, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface OrderInfoContainerProps extends ContainerProps {
  label?: string
}

export const SubmitOrderSection = ({
  label,
  sx,
  ...props
}: OrderInfoContainerProps) => {
  const theme = useTheme()
  return (
    <Container
      key={label}
      {...props}
      maxWidth="lg"
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: 4,
        padding: 2,
        ...(sx as any),
      }}
    >
      <Typography variant="h4">{label}</Typography>
      <Divider sx={{ marginY: 2 }} />
      {props.children}
    </Container>
  )
}
